$('[data-btn="large-text"]').on('click', function() {
    if ('fontSize' in localStorage) {
        localStorage.removeItem('fontSize');
        $('[data-btn="large-text"]').removeClass('active');
        $('html').removeClass('large-text');
    } else {
        $('html').addClass('large-text');
        $('[data-btn="large-text"]').addClass('active');
        localStorage.setItem('fontSize', true);
    }
});

$('document').ready(function(){
    if ('fontSize' in localStorage) {
        $('html').addClass('large-text');
        $('[data-btn="large-text"]').addClass('active');
    } else {
        $('html').removeClass('large-text');
        $('[data-btn="large-text"]').removeClass('active');
    }
});




